var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.698,
    height: 28.698,
    viewBox: "0 0 28.698 28.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14474",
    "data-name": "Group 14474",
    transform: "translate(-1519.706 -156.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14474-2",
    "data-name": "Group 14474",
    transform: "translate(1519.706 156.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13136",
    "data-name": "Group 13136",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 14.349,
    cy: 14.349,
    r: 14.349,
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14475",
    "data-name": "Group 14475",
    transform: "translate(2848.921 -315.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14476",
    "data-name": "Group 14476"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3177",
    "data-name": "Rectangle 3177",
    width: 7.676,
    height: 7.676,
    rx: 2,
    transform: "translate(-1323.519 477.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3182",
    "data-name": "Rectangle 3182",
    width: 7.676,
    height: 7.676,
    rx: 2,
    transform: "translate(-1323.519 486.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3181",
    "data-name": "Rectangle 3181",
    width: 7.676,
    height: 7.676,
    rx: 2,
    transform: "translate(-1313.851 477.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3183",
    "data-name": "Rectangle 3183",
    width: 7.676,
    height: 7.676,
    rx: 2,
    transform: "translate(-1313.851 486.209)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizeSquare);
export default __webpack_public_path__ + "static/media/organize-square.da270f27841b30cacbdbf85f5fffcdee.svg";
export { ForwardRef as ReactComponent };